/**
 * echarts图表类型枚举
 */
export enum ChartType {
  /**
   * 地图
   */
  Map = 'map',
  /**
   * 柱状图
   */
  Bar = 'bar',
  /**
   * 横向柱状图
   */
  HorizontalBar = 'horizontalBar',
  /**
   * 折线图
   */
  Line = 'line',
  /**
   * 饼图
   */
  Pie = 'pie',
}
